import HTTP from 'services/http';

export const fetchShippingHolidays = async (customerId: number) => {
  const request = await HTTP.get(`/shipping/customer/${customerId}/holidays`, {});
  return {
    payload: request.data,
  };
};
